import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  getWaterBacteriaKey,
  getWaterMineralKey,
  getWaterQualityKey,
} from 'common/constants/queryKeys'
import useCycleApi from 'common/hooks/useCycleApi'

import {
  WATER_MINERAL_REQUEST_CONFIG,
  WATER_QUALITY_REQUEST_CONFIG,
  WATER_VIBRIO_REQUEST_CONFIG,
} from '.'
import {
  CreateWaterBacteriaVariables,
  CreateWaterMineralVariables,
  CreateWaterQualityVariables,
  DeleteWaterQualityVariables,
  EditWaterMineralVariables,
  EditWaterVibrioVariables,
} from './types'

export const useMutateCreateWaterQuality = () => {
  const cycleApi = useCycleApi()
  const queryClient = useQueryClient()

  return useMutation(
    ({ body: data }: CreateWaterQualityVariables) =>
      cycleApi.request({ ...WATER_QUALITY_REQUEST_CONFIG.create, data }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getWaterQualityKey.all() })
      },
    }
  )
}

export const useMutateCreateWaterMineral = () => {
  const cycleApi = useCycleApi()
  const queryClient = useQueryClient()

  return useMutation(
    ({ body: data }: CreateWaterMineralVariables) =>
      cycleApi.request({ ...WATER_MINERAL_REQUEST_CONFIG.create, data }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getWaterMineralKey.all() })
      },
    }
  )
}

export const useMutateCreateWaterBacteria = () => {
  const cycleApi = useCycleApi()
  const queryClient = useQueryClient()

  return useMutation(
    ({ body: data }: CreateWaterBacteriaVariables) =>
      cycleApi.request({ ...WATER_VIBRIO_REQUEST_CONFIG.create, data }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getWaterBacteriaKey.all() })
      },
    }
  )
}

export const useMutatePatchWaterQuality = () => {
  const cycleApi = useCycleApi()
  const queryClient = useQueryClient()

  return useMutation(
    ({ body: data }: CreateWaterQualityVariables) =>
      cycleApi.request({ ...WATER_QUALITY_REQUEST_CONFIG.edit, data }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getWaterQualityKey.all() })
      },
    }
  )
}

export const useMutateDeleteWaterQuality = () => {
  const cycleApi = useCycleApi()
  const queryClient = useQueryClient()

  return useMutation(
    ({ params }: DeleteWaterQualityVariables) =>
      cycleApi.request({ ...WATER_QUALITY_REQUEST_CONFIG.delete, params }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getWaterQualityKey.all() })
      },
    }
  )
}

export const useMutatePatchWaterMineral = () => {
  const cycleApi = useCycleApi()
  const queryClient = useQueryClient()

  return useMutation(
    ({ mineralId, body: data }: EditWaterMineralVariables) =>
      cycleApi.request({
        ...WATER_MINERAL_REQUEST_CONFIG.edit,
        url: `${WATER_MINERAL_REQUEST_CONFIG.edit.url}/${mineralId}`,
        data,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getWaterMineralKey.all() })
      },
    }
  )
}

export const useMutateDeleteWaterMineral = () => {
  const cycleApi = useCycleApi()
  const queryClient = useQueryClient()

  return useMutation(
    (mineralId: number) =>
      cycleApi.request({
        ...WATER_MINERAL_REQUEST_CONFIG.delete,
        url: `${WATER_MINERAL_REQUEST_CONFIG.delete.url}/${mineralId}`,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getWaterMineralKey.all() })
      },
    }
  )
}

export const useMutatePatchWaterVibrio = () => {
  const cycleApi = useCycleApi()
  const queryClient = useQueryClient()
  return useMutation(
    ({ vibrioId, body: data }: EditWaterVibrioVariables) =>
      cycleApi.request({
        ...WATER_VIBRIO_REQUEST_CONFIG.edit,
        url: `${WATER_VIBRIO_REQUEST_CONFIG.edit.url}/${vibrioId}`,
        data,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getWaterBacteriaKey.all() })
      },
    }
  )
}

export const useMutateDeleteWaterVibrio = () => {
  const cycleApi = useCycleApi()
  const queryClient = useQueryClient()
  return useMutation(
    (vibrioId: number) =>
      cycleApi.request({
        ...WATER_VIBRIO_REQUEST_CONFIG.delete,
        url: `${WATER_VIBRIO_REQUEST_CONFIG.delete.url}/${vibrioId}`,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getWaterBacteriaKey.all() })
      },
    }
  )
}
